import { SocureKycStatus } from '~/services/users/types';

/**
 * KYC result statuses that keep the user on the verification form rather than
 * navigating to another screen — they must correct and resubmit their details.
 *
 * Unlike the navigating statuses (accept/reject/refer/review), these do NOT
 * unmount the form, so any post-success loading state has to be released
 * explicitly. See {@link getKycButtonLoading}.
 */
export const NON_NAVIGATING_KYC_STATUSES: ReadonlySet<SocureKycStatus> = new Set([
  SocureKycStatus.RESUBMIT,
  SocureKycStatus.MISSING,
]);

export function getKycButtonLoading(
  isMutationLoading: boolean,
  isMutationSuccess: boolean,
  lastStatus: SocureKycStatus | null
): boolean {
  if (isMutationLoading) {
    return true;
  }

  if (isMutationSuccess) {
    return lastStatus === null || !NON_NAVIGATING_KYC_STATUSES.has(lastStatus);
  }

  return false;
}
